import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "@/i18n";
import { LANGS, PAGE_KEYS, pathFor, isValidLang, DEFAULT_LANG, detectLang } from "@/config/site";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import TimelinePage from "@/pages/TimelinePage";
import MusicPage from "@/pages/MusicPage";
import FilmPage from "@/pages/FilmPage";
import StylePage from "@/pages/StylePage";
import LegacyPage from "@/pages/LegacyPage";
import AboutPage from "@/pages/AboutPage";
import DisclaimerPage from "@/pages/DisclaimerPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import NotFound from "@/pages/NotFound";

const COMPONENTS = {
  home: Home,
  timeline: TimelinePage,
  music: MusicPage,
  film: FilmPage,
  style: StylePage,
  legacy: LegacyPage,
  about: AboutPage,
  disclaimer: DisclaimerPage,
  contact: ContactPage,
  privacy: PrivacyPage,
};

function PageWrapper({ lang, pageKey, Component }) {
  const code = isValidLang(lang) ? lang : DEFAULT_LANG;
  return (
    <I18nProvider lang={code}>
      <Layout pageKey={pageKey}>
        <Component pageKey={pageKey} />
      </Layout>
    </I18nProvider>
  );
}

function CatchAll() {
  const location = useLocation();
  const seg = location.pathname.split("/").filter(Boolean)[0];
  const lang = isValidLang(seg) ? seg : DEFAULT_LANG;
  return (
    <I18nProvider lang={lang}>
      <Layout pageKey="home"><NotFound /></Layout>
    </I18nProvider>
  );
}

function RootRedirect() {
  return <Navigate to={pathFor(detectLang(), "home")} replace />;
}

function App() {
  const routes = [];
  LANGS.forEach((l) =>
    PAGE_KEYS.forEach((pk) =>
      routes.push(
        <Route
          key={`${l.code}-${pk}`}
          path={pathFor(l.code, pk)}
          element={<PageWrapper lang={l.code} pageKey={pk} Component={COMPONENTS[pk]} />}
        />,
      ),
    ),
  );

  return (
    <BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        {routes}
        <Route path="*" element={<CatchAll />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
